import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/Card';
import { PathRow } from './PathRow';
import { cn } from '../../lib/utils';

export function PathList({
  title,
  paths = [],
  selectedPathId,
  onSelectPath,
  className,
}) {
  const maxShare = Math.max(...paths.map((path) => path.share), 0.01);

  return (
    <Card className={cn('min-w-0', className)}>
      <CardHeader className="px-4 py-3 sm:px-5">
        <div className="flex items-center justify-between gap-3">
          <CardTitle>{title}</CardTitle>
          <span className="shrink-0 text-[10px] font-semibold uppercase tracking-wide text-slate-400">
            By share
          </span>
        </div>
      </CardHeader>
      <CardContent className="space-y-2 px-3 py-3 sm:px-4">
        {paths.map((path, index) => (
          <PathRow
            key={path.id}
            path={path}
            rank={index + 1}
            maxShare={maxShare}
            selected={selectedPathId === path.id}
            onSelect={onSelectPath}
          />
        ))}
      </CardContent>
    </Card>
  );
}
